// extracted by mini-css-extract-plugin
var _1 = "NavigationFooter_backButton__6H2HT";
var _2 = "768px";
var _3 = "NavigationFooter_navigationFooterContainer__4I0Nj";
var _4 = "NavigationFooter_nextButton__wNrKB";
var _5 = "NavigationFooter_oneButton__zT3o0";
var _6 = "'../../shared.module.css'";
export { _1 as "backButton", _2 as "md", _3 as "navigationFooterContainer", _4 as "nextButton", _5 as "oneButton", _6 as "shared" }
